import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyFormat'
})
export class currencyFormatPipe implements PipeTransform {

  transform(value: number|number[], currency: string = 'USD'): string {
    let currencyValue = value;

    if (Array.isArray(currencyValue))
      currencyValue = currencyValue[0]; 

    return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(currencyValue);
  }
}